module.exports = __webpack_public_path__ + "media/svg/it-58e75ceb.svg";